import React from 'react';
import Navbar from './components/Navbar';
import Welcome from './components/Welcome';
import AboutUs from './components/AboutUs';
import Recommendations from './components/Recommendations.js';
import Content from './components/Content';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop.js';


function Home() {

  return (
    <div className="Home">
      <Navbar />
      <Welcome />
      <AboutUs />
      <Recommendations />
      <Content />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default Home;